import { Button } from "antd";
import React from "react";
import "./fullScreenLoader.scss";

export default function FullScreenLoader({
  comingFrom = "",
  specialMsg,
  msg,
  handleBackToTest,
  handleBackToHome,
  Component = undefined,
}) {
  return (
    <div className="fullScreenCancel">
      <h1 className="warning-msg">{specialMsg}</h1>
      <h1 className="warning-msg">{msg}</h1>
      {Component && <Component />}
      <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {handleBackToTest && (
        <div className="fullscreen-btns">
          <button onClick={handleBackToHome} className="fullscreen-btn one">
            {comingFrom === "startTest"
              ? "Dashboard"
              : comingFrom === "calibration"
              ? "Calibration"
              : comingFrom === "mappr_tracker" ? "MAPPR Tracker" : "MAPPR"}
          </button>
          <button onClick={handleBackToTest} className="fullscreen-btn">
            Go Back To Test
          </button>
        </div>
      )}
    </div>
  );
}
